module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn-document-fe748f43df24affb64981ecc11937c0d.svg";